import React, { useState, useEffect } from 'react';

const FloatingApplyButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [hasAppeared, setHasAppeared] = useState(false);

  const isTrustEdgeMode = process.env.REACT_APP_MODE === "trustedge";

  useEffect(() => {
    const timer = setTimeout(() => setHasAppeared(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const throttle = (func, limit) => {
      let inThrottle;
      return (...args) => {
        if (!inThrottle) {
          func(...args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      };
    };

    const handleScroll = throttle(() => {
      const currentScrollY = window.scrollY;
      setIsVisible(currentScrollY <= lastScrollY || currentScrollY <= 100);
      setLastScrollY(currentScrollY);
    }, 100);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleApplyClick = () => {
    window.open('https://docs.google.com/forms/d/164dEI9sipU0u72BXJ9TX6CArQFCz5U9DrgEeosz4o3w/viewform?edit_requested=true', '_blank');
  };

  if (!isTrustEdgeMode) return null;

  return (
    <div className={`floating-apply-container ${hasAppeared ? 'has-appeared' : 'initial-hidden'} ${isVisible ? 'container-visible' : 'container-hidden'}`}>
      {isExpanded && (
        <div className="floating-apply-overlay" onClick={() => setIsExpanded(false)} />
      )}
      
      <div className={`floating-apply-button ${isExpanded ? 'expanded' : ''}`}>
        {isExpanded && (
          <div className="apply-card">
            <div className="apply-card-header">
              <h3>🎓 Ready to Start Your Journey?</h3>
              <button className="close-button" onClick={() => setIsExpanded(false)}>×</button>
            </div>
            <div className="apply-card-content">
              <p>Join thousands of students advancing their careers with IIT Bombay's professional certificate programs.</p>
              <ul>
                <li>🎓 Get a Highly Regarded IITB-Branded Certificate</li>
                <li>📚 Expert-designed curriculum</li>
                <li>👨‍💻 Practical Code Walkthroughs</li>
                <li>🧪 Weekly Labs to Practice</li>
              </ul>
              <button className="apply-button" onClick={handleApplyClick}>
                🚀 Register Here
              </button>
            </div>
          </div>
        )}
        
        <button className="fab-button" onClick={() => setIsExpanded(!isExpanded)} title="Apply for courses">
          <span className="fab-icon">🎯</span>
          <span className="fab-text">Apply Now</span>
        </button>
      </div>

      <style jsx>{`
        .floating-apply-container {
          position: fixed; bottom: 20px; right: 20px; z-index: 1000;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .initial-hidden { transform: translateY(120px) scale(0.3); opacity: 0; pointer-events: none; }
        .has-appeared { animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55); }
        .container-hidden { transform: translateY(120px) scale(0.8); opacity: 0; pointer-events: none; }
        .container-visible { transform: translateY(0) scale(1); opacity: 1; pointer-events: auto; }
        
        @keyframes bounceIn {
          0% { transform: translateY(120px) scale(0.3); opacity: 0; }
          50% { transform: translateY(-10px) scale(1.1); opacity: 0.8; }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
        @keyframes pulse {
          0%, 100% { box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3); }
          50% { box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5); }
        }
        @keyframes slideUpFade {
          to { transform: translateY(0); opacity: 1; }
        }

        .floating-apply-overlay {
          position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
          background: rgba(0, 0, 0, 0.1); z-index: 999;
        }
        .floating-apply-button { position: relative; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
        .expanded .fab-icon { transform: rotate(180deg); }

        .apply-card {
          position: absolute; bottom: 80px; right: 0; width: 320px;
          background: white; border-radius: 16px; overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
          transform: translateY(10px); opacity: 0;
          animation: slideUpFade 0.3s ease-out forwards;
        }
        .apply-card-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white; padding: 20px; display: flex;
          justify-content: space-between; align-items: center;
        }
        .apply-card-header h3 { margin: 0; font-size: 18px; font-weight: 600; }
        .close-button {
          background: none; border: none; color: white; font-size: 24px;
          cursor: pointer; width: 30px; height: 30px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          transition: background-color 0.2s;
        }
        .close-button:hover { background-color: rgba(255, 255, 255, 0.2); }
        .apply-card-content { padding: 20px; }
        .apply-card-content p { margin: 0 0 16px 0; color: #666; line-height: 1.5; }
        .apply-card-content ul { list-style: none; padding: 0; margin: 0 0 20px 0; }
        .apply-card-content li { padding: 8px 0; color: #555; font-size: 14px; }

        .apply-button, .fab-button {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white; border: none; border-radius: 8px; font-weight: 600;
          cursor: pointer; transition: all 0.2s;
        }
        .apply-button {
          width: 100%; padding: 14px 20px; font-size: 16px;
        }
        .apply-button:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3); }
        
        .fab-button {
          padding: 16px 20px; border-radius: 50px; font-size: 16px;
          display: flex; align-items: center; gap: 8px;
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
          animation: pulse 2s infinite;
        }
        .fab-button:hover { transform: translateY(-3px); box-shadow: 0 12px 30px rgba(102, 126, 234, 0.4); animation: none; }
        .fab-icon { font-size: 20px; transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
        .fab-text { font-size: 14px; font-weight: 600; }

        @media (max-width: 768px) {
          .floating-apply-container { right: 16px; }
          .apply-card { width: calc(100vw - 40px); right: -16px; }
          .fab-button { padding: 14px 18px; font-size: 14px; }
          .fab-icon { font-size: 18px; }
          .fab-text { font-size: 12px; }
        }
        @media (max-width: 480px) {
          .apply-card { width: calc(100vw - 32px); right: -8px; }
        }
      `}</style>
    </div>
  );
};

export default FloatingApplyButton;